import React from 'react'

const GatsbyDataContext = React.createContext({})

export default GatsbyDataContext
export const { Provider: GatsbyDataProvider } = GatsbyDataContext
